import { render, staticRenderFns } from "./CreateFabricOrder.vue?vue&type=template&id=277d3b8b&"
import script from "./CreateFabricOrder.vue?vue&type=script&lang=js&"
export * from "./CreateFabricOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateFabricOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports